import BaseClient from '@/app/model/api/response/baseApiClient'

class GraphApi extends BaseClient {
  public getGraphData (id: string, type: string, flag: boolean) {
    const path = '/v1/field/graph'
    var url = new URL(process.env.VUE_APP_API_URL + path)
    var params

    if (flag) {
      params = new URLSearchParams({ type: type, field_id: id })
    } else {
      params = new URLSearchParams({ type: type, planting_id: id })
    }
    url.search = params.toString()

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }
}
export default new GraphApi()
